export default __webpack_public_path__ + "static/cs-email-automation-b276863a62db84edb5c3e0e178175e89.webp";